import HomeSection from "./HomeSection";
import RoundsCriteria from "./RoundsCriteria";
import FAQ from "./FAQ";

function LandingPage() {
  return (
    <>
      <HomeSection />
      <RoundsCriteria />
      <FAQ />
    </>
  );
}

export default LandingPage;

